import AnimationThemeProvider from "./_helper/AnimationTheme/AnimationThemeProvider";
import {
  default as CustomizerProvider,
  default as CustomProvider,
} from "./_helper/customizer/CustomizerProvider";
import ProductProvider from "./_helper/ecommerce/product/ProductProvider";
import Routers from "./Routes";
import AuthProvider from "./_helper/Auth/AuthProvider";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import ScrollToTop from "./ScrollToTop";
import HousingInspectionProvider from "./Pages/Makkah/HousingAndAccommodations/HousingInspectionContext/housingContext";
import { useEffect } from "react";
import { useRefreshCurrentUser } from "./utils/hooks/useRefreshCurrentUser";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Disable refetch on window focus globally
      refetchOnWindowFocus: false,
      // Disable retry globally
      retry: false,
      
    },
  },
});

function RefreshCurrentUserOnLoad() {
  const refreshCurrentUser = useRefreshCurrentUser();

  useEffect(() => {
    refreshCurrentUser();
    // Call /me once on full app load (browser refresh)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}

function App() {
  return (
    <CustomizerProvider>
      <CustomProvider>
        <ProductProvider>
          <AnimationThemeProvider>
            <BrowserRouter basename={"/"}>
              <AuthProvider>
                <RefreshCurrentUserOnLoad />
                <QueryClientProvider client={queryClient}>
                  <HousingInspectionProvider>
                    <ScrollToTop />
                    <Routers />
                  </HousingInspectionProvider>
                </QueryClientProvider>
              </AuthProvider>
            </BrowserRouter>
          </AnimationThemeProvider>
        </ProductProvider>
      </CustomProvider>
    </CustomizerProvider>
  );
}
export default App;
